





























import { Prop, Vue, Watch } from "vue-property-decorator";
import Component from "vue-class-component";

import { capitalizeFilter } from "@/filters/capitalize.filter";

import { FalconFilterOptions } from "@/interfaces/falcon/shared/falcon-filter-options";

import { I18nMessageKey } from "@/enums/i18n-message-key.enum";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Falcon filters form component
 */
@Component({
  filters: {
    ...capitalizeFilter
  }
})
export default class FilterOptionsForm extends Vue {
  @Prop() private setFilterOptions!: (
    filterOptions: FalconFilterOptions
  ) => void;
  @Prop({ required: false, default: "" }) initialDateFrom!: string;

  @Watch("initialDateFrom", { immediate: true })
  private initialDateFromSpecified(newVal: string): void {
    this.dateFrom = newVal;
  }

  /** Optional start date filter value */
  dateFrom = "";

  /** Optional end date filter value */
  dateTo = "";

  i18nMessageKeyEnum = I18nMessageKey;

  mounted(): void {
    this.invokeFilterOptionsSetter();
  }

  filterOptionsUpdated(event: InputEvent): void {
    if ((event.target as HTMLElement).tagName.toLowerCase() !== "input") {
      return;
    }
    this.invokeFilterOptionsSetter();
  }

  private invokeFilterOptionsSetter(): void {
    this.setFilterOptions({
      dateFrom: this.dateFrom,
      dateTo: this.dateTo
    });
  }
}
